module.exports = __webpack_public_path__ + "static/media/43c37dbc-5b92-4932-a0cb-b7ab156df87c.90a80118.png";